export const set_month = (month_data) => ({
  type: 'set_month',
  payload: month_data,
});
export const set_year = (year_data) => ({
  type: 'set_year',
  payload: year_data,
});
